import * as React from 'react';
import { useDispatch } from 'react-redux';

import { handleRedirectToJkEstimator } from '../../../actions/handleRedirectToJkEstimator';
import { TThunkDispatch } from '../../../types/redux';

/**
 * Редиректим на страницу оценки ЖК
 */
export function useHandleJKSubmit() {
  const dispatch = useDispatch<TThunkDispatch>();

  return React.useCallback(() => {
    dispatch(handleRedirectToJkEstimator());
  }, [dispatch]);
}
